export const asReadEnvelope = {
  data: `<svg width="14" height="14" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
  <path d="M13.6602 5.33366C13.6602 4.85366 13.4135 4.43366 13.0335 4.20033L7.00016 0.666992L0.966829 4.20033C0.586829 4.43366 0.333496 4.85366 0.333496 5.33366V12.0003C0.333496 12.7337 0.933496 13.3337 1.66683 13.3337H12.3335C13.0668 13.3337 13.6668 12.7337 13.6668 12.0003L13.6602 5.33366ZM12.3268 5.33366V5.34033L7.00016 8.66699L1.66683 5.33366L7.00016 2.21366L12.3268 5.33366ZM1.66683 12.0003V6.89366L7.00016 10.2403L12.3268 6.91366L12.3335 12.0003H1.66683Z" />
  </svg>
  `,
  name: 'readEnvelope',
};
